export default __webpack_public_path__ + "static/media/apostrof.c78c6b69.svg";